export const CardType = {
    TEAM: 'Favorite Team Card',
    EDIT: 'Edit Card',
    PLAYER: 'Player Card',
};
